export const FieldMapping = {
  EMAIL: 'EMAIL',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  PASSWORD: 'PASSWORD',
  NULL: 'NULL',
};

export const NAMES_TO_COLUMNS = {
  email: FieldMapping.EMAIL,
  emails: FieldMapping.EMAIL,
  'e mail': FieldMapping.EMAIL,
  'e mails': FieldMapping.EMAIL,
  'electronic mail': FieldMapping.EMAIL,
  'email address': FieldMapping.EMAIL,

  'first name': FieldMapping.FIRST_NAME,
  firstname: FieldMapping.FIRST_NAME,
  'first names': FieldMapping.FIRST_NAME,
  fname: FieldMapping.FIRST_NAME,
  first: FieldMapping.FIRST_NAME,
  'name.first': FieldMapping.FIRST_NAME,
  forename: FieldMapping.LAST_NAME,

  'last name': FieldMapping.LAST_NAME,
  surname: FieldMapping.LAST_NAME,
  lastname: FieldMapping.LAST_NAME,
  'last names': FieldMapping.LAST_NAME,
  lname: FieldMapping.LAST_NAME,
  last: FieldMapping.LAST_NAME,
  'name.last': FieldMapping.LAST_NAME,

  password: FieldMapping.PASSWORD,
  pass: FieldMapping.PASSWORD,
};

export function guessHeader(row) {
  const columns = {};

  let idx = 0;
  for (const val of row) {
    if (val) {
      const cellValue = val.toLowerCase();
      if (typeof NAMES_TO_COLUMNS[cellValue] !== 'undefined') {
        columns[NAMES_TO_COLUMNS[cellValue]] = idx;
      }
    }
    idx++;
  }

  return columns;
}

export function processUsersFile(file) {
  if (file.rows.length === 0) {
    return {};
  }

  const columns = guessHeader(file.rows[0]);
  let hasHeader = true;

  if (Object.keys(columns).length === 0) {
    hasHeader = false;
  }

  if (columns[FieldMapping.EMAIL] === undefined) {
    columns[FieldMapping.EMAIL] = 0;
  }

  if (columns[[FieldMapping.FIRST_NAME]] === undefined) {
    columns[[FieldMapping.FIRST_NAME]] = 1;
  }

  if (columns[FieldMapping.LAST_NAME] === undefined) {
    columns[FieldMapping.LAST_NAME] = 2;
  }

  if (columns[FieldMapping.PASSWORD] === undefined) {
    columns[FieldMapping.PASSWORD] = 3;
  }

  const rows = [];
  file.rows.forEach(r => {
    rows.push([r[columns.EMAIL], r[columns.FIRST_NAME], r[columns.LAST_NAME], r[columns.PASSWORD]]);
  });

  return {
    hasHeader,
    columns: [Object.keys(columns)],
    rows,
  };
}
